module.exports = __webpack_public_path__ + "img/novos-talentos-titulo.379895c2.png";